import styled from 'styled-components';

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin: 16px 0;
  padding-left: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.14px;
`;
